export const STORAGE_NAME = 'isNotificationSeen';
